module.exports = __webpack_public_path__ + "static/img/iWMS-icon.9e442a30.png";